import { render } from "./Module.vue?vue&type=template&id=46e1ebfb"
import script from "./Module.vue?vue&type=script&lang=js"
export * from "./Module.vue?vue&type=script&lang=js"

import "./Module.vue?vue&type=style&index=0&id=46e1ebfb&lang=css"

import exportComponent from "/Users/alejandropascual/Websites/_CODEABLE/Task-171603-Beat/wordpress/wp-content/plugins/aps-modul-booking/_vue/shortcode_modul_courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__